<template>
  <div>
    <h4>
      <RouterLink
        class="routerlink"
        :to="{ name: 'modeditormod', params: { mod: mod } }"
      >
        <i class="fa fa-angle-double-left" />Back </RouterLink>| Editing chapter <b>{{ chapter }}</b> of
      <b>{{ mod }}</b>
    </h4>

    <ElRow :gutter="24">
      <ElCol :span="6">
        <label>Iconic Image</label>
        <img :src="currentChapter.thumb" />
      </ElCol>

      <ElCol :span="16">
        <label>Name</label>
        <input
          type="text"
          v-model="currentChapter.name"
        />
        <label>Slug</label>
        <input
          type="text"
          v-model="currentChapter.slug"
        />
        <label>Introduction</label>
        <VueEditor
          rows="10"
          v-model="currentChapter.intro"
          :editor-toolbar="customToolbar"
        />
      </ElCol>

      <ElCol :span="2" />
    </ElRow>
    <ElRow :gutter="24">
      <ElCol :span="24">
        <Center>
          <br />
          <ElButton
            class="button"
            type="primary"
            @click="saveChapter(currentChapter)"
          >Save</ElButton>
        </Center>
      </ElCol>
    </ElRow>
    <hr />

    <!-- all content items in this chapter -->
    <div
      :key="k"
      v-for="(child, k) in childs"
    >
      <ElRow :gutter="24">
        <ElCol :span="6">
          <img :src="child.icon.url" />
        </ElCol>

        <ElCol :span="16">
          <label>Name</label>
          <input
            type="text"
            v-model="child.title"
          />
          <label>Slug</label>
          <input
            type="text"
            v-model="child.slug"
          />
          <label>Introduction</label>
          <VueEditor
            rows="10"
            v-model="child.intro"
            :editor-toolbar="customToolbar"
          />
          <label>Embed</label>
          <textarea
            rows="10"
            v-model="child.embed_code"
          />
          </ElCol>
        <ElCol :span="2" />
      </ElRow>

      <ElRow :gutter="24">
        <ElCol :span="24">
          <Center>
            <ElButton class="button" type="primary" @click="saveChild(child)"
              >Save</ElButton
            >
            <hr />
          </Center>
        </ElCol>
      </ElRow>
    </div>
  </div>
</template>
<script>
import { VueEditor } from "vue2-editor"
import { API } from "@/tic"

export default {
  name: "ModEditorChapter",
  props: {
    mod: {
      type: String,
      default: ""
    },
    chapter: {
      type: String,
      default: ""
    }
  },
  components: { VueEditor },

  mounted () {
    if (this.mod) {
      API.get("/get-historical-content/" + this.mod).then(r => {
        this.record = r.data.data
      })
    }

    if (this.chapter) {
      this.isLoading = true
      API.get(`/get-hc-items/${this.chapter}`).then(resp => {
        this.childs = { ...resp.data.data }
        this.currentChapter = this.record.chapters
          .filter(e => {
            return e.slug === this.chapter
          })
          .pop()
      })
    }
  },

  methods: {
    saveChapter (chapter) {
      API.post("/admin/module/chapterintro/save", chapter)
        .then(() => {
          this.$notify.success("Chapter intro saved")
        })
        .catch(r => {
          this.$notify.error(`${r}`)
        })
    },

    saveChild (child) {
      API.post("/admin/moduleitem/save", child)
        .then(() => {
          this.$notify.success("item saved")
        })
        .catch(r => {
          this.$notify.error(`${r}`)
        })
    }
  },

  data () {
    return {
      modules: [],
      record: {},
      icon: {},
      childs: [],
      isLoading: false,
      currentChapter: {},
      customToolbar: [
        ["bold", "italic", "underline", "strike"],
        [
          { align: "" },
          { align: "center" },
          { align: "right" },
          { align: "justify" }
        ],
        ["blockquote"],
        [{ indent: "-1" }, { indent: "+1" }],
        [{ list: "ordered" }, { list: "bullet" }],
        ["link"],
        ["clean"]
        // ['image', 'code-block']
      ]
    }
  }
}
</script>
<style scoped>
label {
  font-weight: bold;
  margin-top: 20px;
  margin-bottom: 10px;
  display: inline-block;
}
</style>